import Button from './Button';

import './ConfirmationWarning.scss';

const ConfirmationAlert = ({
	title,
	subtitle,
	confirmLabel,
	onConfirm
}) => {
	return (
		<>
			<section>
				<header>
					<h4>{title}</h4>
				</header>
			</section>
			<div className='confirmation-Warning-subtitle'>
				<p>{subtitle}</p>
			</div>
			<footer className='confirmation-warning-action-button'>
				<Button
					className='primary-button'
					onClick={onConfirm}
				>
					{confirmLabel}
				</Button>
			</footer>
		</>
	);
};

export default ConfirmationAlert;
